<div class="jsd-home">
    <div class="jsd-home__mobile">
        <section class="jsd-home__mobile__download">
            <div class="jsd-home__mobile__download--background">
                <img ngSrc="assets/images/bg-bike-1.svg" alt="background-bike" height="249" width="267">
            </div>
            <h1 class="download-wrap">
                <span class="download-wrap-background">baixe</span>
                <span class="download-wrap-info">baixe</span>
                <span class="download-wrap-focus">agora!</span>
            </h1>
            <article>
                <div class="app-warp">
                    <img ngSrc="assets/images/james-app-login.svg" alt="James App" height="322" width="149">
                </div>
                <a class="btn"
                   href="https://play.google.com/store/apps/details?id=br.com.jamesdelivery.android.courier&pcampaignid=web_share">
                    <img ngSrc="assets/icons/adb.svg" alt="Google Play" height="37" width="24"> Grátis para Android
                </a>
            </article>
        </section>

        <section class="jsd-home__mobile__pra-ja">
            <div class="jsd-home__mobile__pra-ja--background-1">
                <img ngSrc="assets/images/bg-people-1.svg" alt="background-bike" height="200" width="273">
            </div>
            <div class="jsd-home__mobile__pra-ja--background-2">
                <img ngSrc="assets/images/bg-time-2.svg" alt="background-bike" height="78" width="137">
            </div>
            <div class="jsd-home__mobile__pra-ja--background-3">
                <img ngSrc="assets/images/bg-pasta-2.svg" alt="background-bike" height="100" width="123">
            </div>
            <div class="jsd-home__mobile__pra-ja--background-4">
                <img ngSrc="assets/images/bg-people-pin-1.svg" alt="background-bike" height="162" width="251">
            </div>

            <h1 class="slogan-pra-ja">
                <span class="slogan-1">pra toda</span>
                <span class="slogan-2">entrega</span>
                <span class="slogan-3">é para já</span>
            </h1>

            <p>
                Sabe aquela grana extra que é sempre bem-vinda? Comigo, ela tá garantida! Tenha flexibilidade para
                trabalhar
                o
                quanto quiser, em qualquer horário, recebendo a melhor remuneração do mercado de delivery, segundo os
                próprios
                entregadores.
            </p>
            <p>Minha frota é composta por entregadores de carro, moto ou bicicleta. Cada entrega é alocada para o
                entregador ideal com base na distância a ser percorrida, tamanho do pedido e tipo de produto.</p>
        </section>

    </div>
    <div class="jsd-home__desktop">
        <div class="app-warp">
            <img ngSrc="assets/images/james-app-login.svg" alt="James App" height="647" width="299" priority>
        </div>
        <section class="jsd-home__desktop__pra-ja">
            <div class="jsd-home__desktop__pra-ja--background-1">
                <img ngSrc="assets/images/bg-time-2.svg" alt="background-bike" height="78" width="137">
            </div>
            <div class="jsd-home__desktop__pra-ja--background-2">
                <img ngSrc="assets/images/bg-map-1.svg" alt="background-bike" height="210" width="294">
            </div>
            <div class="jsd-home__desktop__pra-ja--background-3">
                <img ngSrc="assets/images/bg-money-1.svg" alt="background-bike" height="205" width="237">
            </div>
            <div class="jsd-home__desktop__pra-ja--background-4">
                <img ngSrc="assets/images/bg-people-1.svg" alt="background-bike" height="441" width="491">
            </div>
            <div class="jsd-home__desktop__pra-ja--background-5">
                <img ngSrc="assets/images/bg-bread-1.svg" alt="background-bike" height="168" width="243">
            </div>
            <div class="jsd-home__desktop__pra-ja--background-6">
                <img ngSrc="assets/images/bg-cake-1.svg" alt="background-bike" height="154" width="324">
            </div>
            <h1 class="slogan-pra-ja">
                <span class="slogan-1">pra toda</span>
                <span class="slogan-2">entrega</span>
                <span class="slogan-3">é para já</span>
            </h1>

            <div class="infos">

                <div class="infos__wrap">
                    <p>
                        Sabe aquela grana extra que é sempre bem-vinda? Comigo, ela tá garantida! Tenha flexibilidade
                        para
                        trabalhar
                        o
                        quanto quiser, em qualquer horário, recebendo a melhor remuneração do mercado de delivery,
                        segundo
                        os
                        próprios
                        entregadores.
                    </p>
                    <p>Minha frota é composta por entregadores de carro, moto ou bicicleta. Cada entrega é alocada para
                        o
                        entregador ideal com base na distância a ser percorrida, tamanho do pedido e tipo de
                        produto.</p>
                </div>
            </div>
        </section>

        <section class="jsd-home__desktop__download">
            <div class="jsd-home__desktop__download--background">
                <img ngSrc="assets/images/bg-bike-1.svg" alt="background-bike" height="249" width="267">
            </div>
            <h1 class="download-wrap">
                <span class="download-wrap-background">baixe</span>
                <span class="download-wrap-info">baixe</span>
                <span class="download-wrap-focus">agora!</span>
            </h1>
            <a class="btn btn-secondary"
               href="https://play.google.com/store/apps/details?id=br.com.jamesdelivery.android.courier&pcampaignid=web_share">
                <img ngSrc="assets/icons/adb.svg" alt="Google Play" height="37" width="24">
                <span class="free-android-text">Grátis para Android</span>
                <img ngSrc="../../../../assets/icons/arrow-right-alt.svg" alt="Acessar" height="32" width="32">
            </a>
        </section>
    </div>
</div>